import {
  CompassCardComponent,
  CompassCardComponentProps,
} from 'react-scale/corp/views/DataCompassV2/types';
import usePassAtKCard from './usePassAtKCard';
import RunInfo from 'react-scale/corp/views/CorpProjectGroupManager/views/Quality/PassAtK/components/RunInfo';

const PassAtKCardComponent: CompassCardComponent = ({ index }: CompassCardComponentProps) => {
  const { runId, runInfo, isLoading } = usePassAtKCard(index);

  return (
    <div className="p-4">
      <div className="space-y-4">
        {runInfo && (
          <RunInfo
            runConfig={runInfo}
            isLoading={isLoading}
            runIds={[runId]}
            linkToCompass={false}
          />
        )}
      </div>
    </div>
  );
};

export default PassAtKCardComponent;
